import { render, staticRenderFns } from "./main.vue?vue&type=template&id=3772f5a1"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3772f5a1')) {
      api.createRecord('3772f5a1', component.options)
    } else {
      api.reload('3772f5a1', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=3772f5a1", function () {
      api.rerender('3772f5a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/analytics/components/download-data/main.vue"
export default component.exports